import { chakra } from '@chakra-ui/react'
import React from 'react'

interface SkipLinkProps {
  targetId: string
  children: React.ReactNode
}

export const SkipLink = ({ targetId, children }: SkipLinkProps) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    document.getElementById(targetId)?.focus()
  }

  return (
    <chakra.a
      href={`#${targetId}`}
      onClick={handleClick}
      position="absolute"
      top="0.5rem"
      left="0.5rem"
      zIndex="skipNav"
      px="1rem"
      py="0.5rem"
      borderRadius="0.5rem"
      bg="bg.panel"
      color="fg.default"
      fontWeight="semibold"
      boxShadow="md"
      transform="translateY(-200%)"
      _focus={{
        transform: 'translateY(0)',
        outline: '2px solid',
        outlineColor: 'brand.solid',
        outlineOffset: '2px',
      }}
    >
      {children}
    </chakra.a>
  )
}
